import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AnyAction } from "redux-saga";
import { ThunkDispatch } from "redux-thunk";

import { GateProps } from "./GateProps";
import * as frontLoaderActions from "../actions/frontLoaderActions";
import { useHasLoaded } from "../hooks/requestStatusHooks";

const StainGate = ({
  children,
  LoadingEl,
  ErrorEl,
  justStains,
}: GateProps & { justStains?: boolean }) => {
  const stainsLoaded = useHasLoaded(frontLoaderActions.frontLoadStains);
  const labStainsLoaded = useHasLoaded(frontLoaderActions.frontLoadLabStains);
  const externalLabsLoaded = useHasLoaded(
    frontLoaderActions.frontLoadExternalLabs
  );
  const externalLabStainsLoaded = useHasLoaded(
    frontLoaderActions.frontLoadExternalLabStains
  );
  const labPanelsLoaded = useHasLoaded(frontLoaderActions.frontLoadLabPanels);
  const antigenRetrievalMethodsLoaded = useHasLoaded(
    frontLoaderActions.frontLoadAntigenRetrievalMethods
  );
  const antibodySpeciesLoaded = useHasLoaded(
    frontLoaderActions.frontLoadAntibodySpecies
  );

  const [hasError, setHasError] = useState(false);
  const dispatch = useDispatch() as ThunkDispatch<any, any, AnyAction>;
  useEffect(() => {
    const promises = [
      dispatch(frontLoaderActions.frontLoadStains({})),
      ...(justStains
        ? []
        : [
            dispatch(frontLoaderActions.frontLoadLabStains({})),
            dispatch(frontLoaderActions.frontLoadExternalLabs({})),
            dispatch(frontLoaderActions.frontLoadExternalLabStains({})),
            dispatch(frontLoaderActions.frontLoadLabPanels({})),
            dispatch(frontLoaderActions.frontLoadAntigenRetrievalMethods({})),
            dispatch(frontLoaderActions.frontLoadAntibodySpecies({})),
          ]),
    ];
    Promise.all(promises).catch(() => {
      setHasError(true);
    });
  }, []);

  if (hasError)
    return <ErrorEl className="StainGate">Failed to load Stains</ErrorEl>;

  if (
    !stainsLoaded ||
    (!justStains &&
      (!labStainsLoaded ||
        !externalLabsLoaded ||
        !externalLabStainsLoaded ||
        !labPanelsLoaded ||
        !antigenRetrievalMethodsLoaded ||
        !antibodySpeciesLoaded))
  ) {
    return <LoadingEl className="StainGate">Loading Stains...</LoadingEl>;
  }

  return <>{children}</>;
};

export default StainGate;
